export const AI_USER_IDS = [22, 23, 24];

export const AI_INBOX_MAP = {
  23: { name: 'Lush', agentId: 22 },
  21: { name: 'Tout', agentId: 24 },
  24: { name: 'Andar de Cima', agentId: 23 },
};

export const PERIOD_OPTIONS = [
  { key: 'today', label: 'Hoje', days: 0 },
  { key: '7d', label: '7 dias', days: 7 },
  { key: '30d', label: '30 dias', days: 30 },
  { key: 'custom', label: 'Personalizado', days: null },
];
